export default "__VITE_ASSET__B0kfZrJR__"